const colors = {
    primary: '#80A6EA',
    secondary: '#5B69B7',
    amazone: '#f0c040',
    variation: 'blue',
    close: '#FF605C',

}

export { colors }